import { Button } from '@talentmesh/ui/components/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { cn } from '@talentmesh/ui/lib/utils';

import { type HTMLPropsRef, type MRT_RowData, type MRT_TableInstance } from '../../types';
import { type ActionIconProps } from '../../types/mrt-ui-props';

interface Props<TData extends MRT_RowData> extends ActionIconProps, HTMLPropsRef<HTMLButtonElement> {
    table: MRT_TableInstance<TData>;
}

export const MRT_ToggleFiltersButton = <TData extends MRT_RowData>({
    table: {
        getState,
        options: {
            icons: { IconFilter, IconFilterOff },
            localization: { showHideFilters },
        },
        setShowColumnFilters,
    },
    title,
    ...rest
}: Props<TData>) => {
    const { showColumnFilters } = getState();

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    {...rest}
                    aria-label={title ?? showHideFilters}
                    className={cn('text-muted-foreground h-9 w-9', rest?.className)}
                    onClick={() => setShowColumnFilters((current) => !current)}
                    size="icon-2xs"
                    variant="ghost"
                >
                    {showColumnFilters ? <IconFilterOff className="size-4" /> : <IconFilter className="size-4" />}
                </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom">{title ?? showHideFilters}</TooltipContent>
        </Tooltip>
    );
};
